import { featureVectorToArray } from "./features.js";
const MAX_PER_LABEL = 600;
export class TrainingSet {
    constructor() {
        Object.defineProperty(this, "byLabel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
    }
    static fromJSON(data) {
        const ts = new TrainingSet();
        for (const [label, rows] of Object.entries(data ?? {})) {
            ts.byLabel.set(label, rows.map((r) => [...r]));
        }
        return ts;
    }
    add(label, f) {
        const arr = featureVectorToArray(f);
        const bucket = this.byLabel.get(label) ?? [];
        bucket.push(arr);
        if (bucket.length > MAX_PER_LABEL) {
            bucket.splice(0, bucket.length - MAX_PER_LABEL);
        }
        this.byLabel.set(label, bucket);
    }
    addMany(label, frames) {
        for (const f of frames)
            this.add(label, f);
    }
    labels() {
        return [...this.byLabel.keys()].sort();
    }
    countFor(label) {
        return this.byLabel.get(label)?.length ?? 0;
    }
    totalFrames() {
        let n = 0;
        for (const b of this.byLabel.values())
            n += b.length;
        return n;
    }
    clearLabel(label) {
        this.byLabel.delete(label);
    }
    clearAll() {
        this.byLabel.clear();
    }
    toFrames() {
        const out = [];
        for (const [label, rows] of this.byLabel) {
            for (const features of rows)
                out.push({ label, features });
        }
        return out;
    }
    toJSON() {
        const out = {};
        for (const [label, rows] of this.byLabel) {
            out[label] = rows.map((r) => [...r]);
        }
        return out;
    }
}
